import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/content-humanizer",
};
